module.exports = __webpack_public_path__ + "af8d575204e841bc37418c3cd6aed4fa.svg";